import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import get from 'lodash/get';

export const useFormFieldError = (name: string) => {
  const methods = useFormContext();
  const errorMessage = get(
    methods,
    `formState.errors.${name}.message`,
    ''
  ) as string;

  const helperText = useMemo(() => {
    if (!errorMessage) {
      return '';
    }
    return <span dangerouslySetInnerHTML={{ __html: errorMessage }} />;
  }, [errorMessage]);

  return {
    error: Boolean(errorMessage),
    helperText,
  };
};
